//******************************************************************************
// import
//------------------------------------------------------------------------------
// PointCloudLayerの拡張に必要なクラス等
import { Layer, project32, gouraudLighting, picking } from "@deck.gl/core";
import { PointCloudLayer } from "@deck.gl/layers";
//------------------------------------------------------------------------------
// 上書きして使用する頂点シェーダ
import vs from "./custom-point-cloud-layer-vertex.glsl";
//------------------------------------------------------------------------------
// フラグメントシェーダはオリジナルをそのまま使用（相対パスのフル指定が必要）
import fs from "../../../node_modules/@deck.gl/layers/dist/point-cloud-layer/point-cloud-layer-fragment.glsl";
// import fs from "./custom-point-cloud-layer-fragment.glsl";

// import { GL } from '@luma.gl/constants';

//******************************************************************************
// export
// PointCloudLayerを拡張（フラグメントシェーダを変更）
export class CustomPointCloudLayer extends PointCloudLayer {

	//**************************************************************************
	// レイヤー名上書き
	static layerName = 'CustomPointCloudLayer';

	//**************************************************************************
	/**
	 * メソッドを上書き
	 * @override
	 * @returns {Object} シェーダーの定義オブジェクト
	 * @property {string} vs - 頂点シェーダーのソースコード
	 * @property {string} fs - フラグメントシェーダーのソースコード
	 * @property {Array<Object>} modules - 使用するシェーダーモジュールのリスト
	 */
	getShaders() {
		return Layer.prototype.getShaders.call(this, {
			vs,
			fs,
			// modules: [project32, gouraudLighting, picking]
			modules: [project32, picking]
		});
	}


	initializeState() {
		super.initializeState();
		const attributeManager = this.getAttributeManager();
		// attributeManager.remove(['instanceNormals']);
		attributeManager.remove([
			'instanceNormals',
			'instancePositions64Low'
		]);
	}

	//**************************************************************************
	/**
	 * 標高グラデーションのためのuniform値を設定するためのメソッド
	 * @param	{{use_offset, use_corfficient}} uniforms uniform変数
	 * @returns	{this}
	*/
	setCustomUniforms(uniforms) {
		//----------------------------------------------------------------------
		// uniform値を格納する
		this._customUniforms = uniforms;
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * 標高グラデーションを使用するか否かのuniform値を設定するためのメソッド
	 * @param {boolean} flag グラデーションを使うか否か
	 * @returns {this}
	*/
	useGradation(flag) {
		//----------------------------------------------------------------------
		// 標高グラデーション使用の真偽値を格納する
		this._useGradation = flag;
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * 追加したuniform値を使用するようメソッドを上書き
	 * @override
	 * @param {Object} opts - 描画オプション
	 * @param {Object} opts.uniforms - 共有されるUniform変数
	 * @param {Object} [opts.parameters] - WebGLの状態設定
	 * @param {Object} [opts.moduleParameters] - シェーダーモジュール設定
	 */
	draw({ uniforms }) {
		super.draw({
			uniforms: {
				...uniforms,
				...(this._customUniforms ?? {}),
				use_gradation: this._useGradation ?? false
			}
		})
	}
}
